import { rem } from 'polished'
import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import Image from 'components/Common/Image'
import InlineGroup from 'components/Common/InlineGroup'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import { getSupportContact } from 'selectors/supportContactSelector'
import { mediaQueryUp } from 'components/utils/breakpoint'

export const CUSTOMER_SUPPORT_IMAGE_ID = 'd5sfjdbpg47k0yfcxxzj'

const BannerContainer = styled(InlineGroup)`
  padding: ${rem(20)} 0;
  border-top: 1px solid ${({ theme }) => theme.palette.neutral.five};
  border-bottom: 1px solid ${({ theme }) => theme.palette.neutral.five};
  grid-area: top-support-banner;

  picture,
  img {
    flex-shrink: 0;

    ${mediaQueryUp.sm} {
      width: ${rem(100)};
    }
  }

  ${mediaQueryUp.sm} {
    gap: ${rem(16)};
  }
`

interface Props {
  currentContact: App.GeoContacts;
}

function CruiseSupportBanner({
  currentContact,
}: Props) {
  const contact = currentContact[currentContact.default]

  return (
    <BannerContainer
      spacing="md"
      vertical="center"
    >
      <Image
        alt="Travel companion on your trip"
        id={CUSTOMER_SUPPORT_IMAGE_ID}
        width="125"
      />
      <VerticalSpacer gap={8}>
        <Heading variant="heading6" colour="neutral-two">
          Our team are available 24 hours, 7 days
        </Heading>
        <BodyText variant="medium" colour="neutral-three">
          Interested in this cruise? Call our dedicated customer service team anytime.
        </BodyText>
        <InlineGroup vertical="center" spacing="md">
          <TextLink
            startIcon={<LinePhoneIcon />}
            size="medium"
            href={`tel:${contact.number}`}
          >
            {contact.humanReadable}
          </TextLink>
        </InlineGroup>
      </VerticalSpacer>
    </BannerContainer>
  )
}

function mapStateToProps(state: App.State) {
  return {
    currentContact: getSupportContact(state),
  }
}

export default connect(mapStateToProps)(CruiseSupportBanner)
